<template>
    <v-card class="elevation-0 w-100 w-md-75" style="margin: auto; background: $white !important">
        <v-window v-model="wizardStep" touchless v-if="showBTWizard" v-show="!documentWizard">
            <v-window-item :value="1">
                <v-card-title class="title font-weight-regular justify-space-between d-flex">
                    <span>Faites votre choix</span>
                    <v-avatar
                        color="primary lighten-2"
                        class="subheading white--text"
                        size="24"
                        v-text="1"
                    />
                </v-card-title>
                <v-card-text>
                    <v-list subheader>
                        <v-list-item
                            class="oss-list-item"
                            :class="listItemClass"
                            @click.stop="wizardStep = 2"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title>J'ai une facture</v-list-item-title
                            ><v-list-item-subtitle
                                >Facture d'achat ou de vente à importer ou déjà
                                importée</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            :class="listItemClass"
                            @click.stop="nextToGeneralWithoutInvoiceStep()"
                            v-if="withoutInvoiceStepCount"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title>Je n'ai pas de facture</v-list-item-title
                            ><v-list-item-subtitle
                                >Facture perdue, commission bancaire, remboursement
                                d'emprunt</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            :class="listItemClass"
                            @click.stop="wizardStep = 6"
                            v-if="zTillBT"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >Encaissement provenant de la caisse</v-list-item-title
                            ><v-list-item-subtitle
                                >Pour les commerces : Dépot d'espèce ou de chèques, CB, Ticket
                                restaurant, ...</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            :class="listItemClass"
                            @click.stop="
                                reconciliationVue.currentAccountAccountableAccount =
                                    reconciliationVue.getDefaultCurrentAccount();
                                wizardStep = 7;
                            "
                            v-if="currentAccountBTItem"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >C'est du
                                {{ reconciliationVue.getCurrentAccountTitle() }}</v-list-item-title
                            ><v-list-item-subtitle
                                >Apport ou remboursement du
                                {{
                                    reconciliationVue.getCurrentAccountTitle()
                                }}</v-list-item-subtitle
                            ></v-list-item
                        >
                        <!-- TOUT FINISH -->
                        <!-- <v-list-item
                            :class="listItemClass"
                            @click.stop="reconciliationVue.bankTransactionPanel = !reconciliationVue.bankTransactionPanel; reconciliationVue.documentPanel=false; reconciliationVue.reconciliationPanel=false"
                            >
                            <template>
                                <v-list-item-title>Je cherche un mouvement bancaire</v-list-item-title>
                                <v-list-item-subtitle>Exemple : remboursement frais bancaire</v-list-item-subtitle>
                            </template>
                            <template v-slot:append>
                                <v-btn icon>
                                    <v-icon color="grey lighten-1">$chevron_right</v-icon>
                                </v-btn>
                            </template>
                        </v-list-item> -->
                    </v-list>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="2">
                <v-card-title class="title font-weight-regular justify-space-between d-flex">
                    <span>Trouver votre facture</span>
                    <v-avatar
                        color="primary lighten-2"
                        class="subheading white--text"
                        size="24"
                        v-text="2"
                    />
                </v-card-title>
                <v-card-text>
                    <v-list subheader>
                        <v-list-item
                            :class="listItemClass"
                            v-if="
                                reconciliationVue.currentUser.profile.configuration.document
                                    .importPurchaseInvoice
                            "
                            @click="startUpload()"
                        >
                            <template v-slot:append>
                                <v-btn-icon
                                    icon="$chevron_right"
                                    :loading="reconciliationVue.loadingDocument"
                                />
                            </template>
                            <v-list-item-title>J'importe une facture</v-list-item-title
                            ><v-list-item-subtitle
                                >Le justificatif n'a pas été importé dans
                                l'application</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            :class="listItemClass"
                            @click="chooseExisitingDocument"
                            v-if="insideBank"
                        >
                            <template v-slot:append>
                                <v-btn-icon
                                    icon="$chevron_right"
                                    :loading="reconciliationVue.loadingDocument"
                                />
                            </template>
                            <v-list-item-title>Je choisis une facture importée</v-list-item-title
                            ><v-list-item-subtitle
                                >Le justificatif a déjà été importé dans
                                l'application</v-list-item-subtitle
                            ></v-list-item
                        >
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        rounded
                        @click="
                            wizardStep = 1;
                            reconciliationVue.documentPanel = false;
                        "
                        size="small"
                    >
                        Précédent
                    </v-btn>
                </v-card-actions>
            </v-window-item>

            <v-window-item :value="3">
                <v-card-title class="title font-weight-regular justify-space-between d-flex">
                    <span>Justifier sans facture</span>
                    <v-avatar
                        color="primary lighten-2"
                        class="subheading white--text"
                        size="24"
                        v-text="2"
                    />
                </v-card-title>
                <v-card-text>
                    <v-list subheader>
                        <v-list-item
                            :class="listItemClass"
                            @click="wizardStep = 8"
                            v-if="withoutInvoiceBT"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >Je n'ai pas la facture ou commission bancaire</v-list-item-title
                            ><v-list-item-subtitle
                                >Le justificatif est perdu ou il s'agit d'une commission
                                bancaire</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            :class="listItemClass"
                            @click="wizardStep = 5"
                            v-if="commissionBTItem"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >Mouvement bancaire avec commission bancaire
                                prelevé</v-list-item-title
                            ><v-list-item-subtitle
                                >Il s'agit d'une vente pour laquelle la commission a été prélevée
                                par la banque</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            :class="listItemClass"
                            @click="wizardStep = 4"
                            v-if="loanBTItem"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title>C'est un emprunt</v-list-item-title
                            ><v-list-item-subtitle v-if="loanBTItem.bt && loanBTItem.bt.amount < 0"
                                >Il s'agit du remboursement d'un emprunt
                                bancaire.</v-list-item-subtitle
                            ><v-list-item-subtitle v-else
                                >Il s'agit d'un prêt bancaire.</v-list-item-subtitle
                            ></v-list-item
                        >
                        <v-list-item
                            :class="listItemClass"
                            @click="wizardStep = 9"
                            v-if="showAutoSalesReconciliation"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >N'est pas à justifier (BNC médicaux)</v-list-item-title
                            ><v-list-item-subtitle
                                >Pour les BNC médicaux il n'est pas oblitoire de justifier les
                                encaissements ou décaissements</v-list-item-subtitle
                            ></v-list-item
                        >
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn rounded @click="wizardStep = 1" size="small"> Précédent </v-btn>
                </v-card-actions>
            </v-window-item>
            <v-window-item :value="4">
                <Loan
                    :step="3"
                    :reconciliationVue="reconciliationVue"
                    :companyId="reconciliationVue.companyId"
                    :btItem="loanBTItem"
                    @added="wizardStep = 1"
                    @cancel="backToGeneralWithoutInvoiceStep()"
                >
                </Loan>
            </v-window-item>
            <v-window-item :value="5">
                <Commission
                    :step="3"
                    :reconciliationVue="reconciliationVue"
                    :companyId="reconciliationVue.companyId"
                    :btItem="commissionBTItem"
                    @added="wizardStep = 1"
                    @cancel="backToGeneralWithoutInvoiceStep()"
                >
                </Commission>
            </v-window-item>
            <v-window-item :value="6">
                <ZTill
                    :step="2"
                    :reconciliationVue="reconciliationVue"
                    :zTillBT="zTillBT"
                    @added="wizardStep = 1"
                    @cancel="wizardStep = 1"
                >
                </ZTill>
            </v-window-item>
            <v-window-item :value="7">
                <CurrentAccount
                    :step="2"
                    :companyId="reconciliationVue.companyId"
                    :btItem="currentAccountBTItem"
                    :reconciliationVue="reconciliationVue"
                    :accountableAccount="reconciliationVue.currentAccountAccountableAccount"
                    @added="wizardStep = 1"
                    @cancel="wizardStep = 1"
                >
                </CurrentAccount>
            </v-window-item>
            <v-window-item :value="8">
                <WithoutInvoice
                    :step="3"
                    :companyId="reconciliationVue.companyId"
                    :btItem="withoutInvoiceBT"
                    @added="wizardStep = 1"
                    @cancel="backToGeneralWithoutInvoiceStep()"
                >
                </WithoutInvoice>
            </v-window-item>
            <v-window-item :value="9">
                <AutoSales
                    :step="3"
                    :companyId="reconciliationVue.companyId"
                    :btItem="showAutoSalesReconciliation"
                    @added="wizardStep = 1"
                    @cancel="backToGeneralWithoutInvoiceStep()"
                >
                </AutoSales>
            </v-window-item>
            <!-- <v-window-item :value="10">
                <WithDelta
                :step="3"
                :reconciliationVue="reconciliationVue"
                @added='wizardStep = 1'
                @cancel='backToGeneralWithoutInvoiceStep()'
                >
                </WithDelta>
            </v-window-item> -->
        </v-window>
        <v-window v-model="wizardStep" touchless v-else-if="showDocWizard">
            <v-window-item :value="1">
                <v-card-title class="title font-weight-regular justify-space-between d-flex">
                    <span>Faites votre choix</span>
                    <v-avatar
                        color="primary lighten-2"
                        class="subheading white--text"
                        size="24"
                        v-text="1"
                    />
                </v-card-title>
                <v-card-text>
                    <v-flex class="text-center mb-2">
                        <v-btn
                            @click="
                                reconciliationVue.bankTransactionPanel =
                                    !reconciliationVue.bankTransactionPanel;
                                reconciliationVue.documentPanel = false;
                                reconciliationVue.reconciliationPanel = false;
                            "
                            class="btn"
                            rounded
                            size="small"
                        >
                            Je cherche un mouvement bancaire
                            <!-- <v-icon right>{{ reconciliationVue.bankTransactionPanel ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon> -->
                        </v-btn>
                    </v-flex>
                    <v-flex class="text-center mb-2">
                        <v-btn
                            :loading="reconciliationVue.loadingDocument"
                            :disabled="reconciliationVue.loadingDocument"
                            rounded
                            class="btn"
                            @click="
                                reconciliationVue.documentPanel = !reconciliationVue.documentPanel;
                                reconciliationVue.bankTransactionPanel = false;
                                reconciliationVue.reconciliationPanel = false;
                            "
                            v-if="reconciliationVue.difference"
                            size="small"
                        >
                            Je choisis une facture importée
                            <!-- <v-icon right>{{ reconciliationVue.documentPanel ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon> -->
                        </v-btn>
                    </v-flex>
                    <v-flex class="text-center mb-2">
                        <v-btn
                            @click="
                                wizardStep = 2;
                                reconciliationVue.bankTransactionPanel = false;
                            "
                            class="btn"
                            rounded
                            v-if="reconciliationVue.cashPaymentDocItem"
                            size="small"
                            >Cette facture a été réglée en espèce
                        </v-btn>
                    </v-flex>
                    <v-flex class="text-center mb-2">
                        <v-btn
                            @click="
                                wizardStep = 3;
                                reconciliationVue.bankTransactionPanel = false;
                            "
                            class="btn"
                            rounded
                            v-if="reconciliationVue.cashPaymentDocItem"
                            size="small"
                            >Cette facture a été payée par un chèque ou un prélèvement ou un
                            virement non encaissé
                        </v-btn>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        rounded
                        @click="
                            wizardStep = 1;
                            reconciliationVue.bankTransactionPanel = false;
                        "
                        size="small"
                    >
                        Précédent
                    </v-btn>
                </v-card-actions>
            </v-window-item>
            <v-window-item :value="2">
                <CashPayment
                    :step="2"
                    :userId="reconciliationVue.currentUser.id"
                    :companyId="reconciliationVue.companyId"
                    :accountingLine="reconciliationVue.cashPaymentDocItem.accountingLine"
                    @added="wizardStep = 1"
                    @cancel="wizardStep = 1"
                >
                </CashPayment>
            </v-window-item>
            <v-window-item :value="3">
                <Remittance
                    :step="3"
                    :userId="reconciliationVue.currentUser.id"
                    :companyId="reconciliationVue.companyId"
                    :accountingLine="reconciliationVue.cashPaymentDocItem.accountingLine"
                    @added="wizardStep = 1"
                    @cancel="wizardStep = 1"
                >
                </Remittance>
            </v-window-item>
        </v-window>
        <template v-else>
            <v-card-title class="title font-weight-regular justify-space-between d-flex">
                <span>Statut</span>
                <v-avatar color="secondary" class="subheading white--text" size="24">
                    <v-icon dark>$check</v-icon>
                </v-avatar>
            </v-card-title>
            <v-card-text>
                <v-flex xs12 class="ma-2">{{ status }}</v-flex>
                <!-- <v-flex xs12 class="ma-2 text-center">
                    <v-btn
                        v-if="showValidate"
                        :disabled="reconciliationVue.saveIsDisabled"
                        :loading="validateLoading"
                        class="btn"
                        rounded
                         size="small"
                        color="secondary"
                        @click="validate()"
                    >Valider</v-btn>
                </v-flex> -->
            </v-card-text>
        </template>
        <div class="d-flex w-100 flex-column" v-if="documentWizard">
            <DocumentWizard
                :companyId="reconciliationVue.companyId"
                :showFirstPrevious="true"
                :amount="-reconciliationVue.difference"
                :documentType="documentType"
                :multiple="false"
                @new-document="onNewDocument"
                @close="documentWizard = false"
                @globalStep="onGlobalStepChange"
                @files-uploaded="onFileUploaded"
            />
            <div v-if="showDocumentWizardPreviousBtn">
                <v-btn
                    :block="false"
                    size="small"
                    class="ma-3"
                    @click="
                        wizardStep = 2;
                        // reconciliationVue.documentPanel = false;
                        documentWizard = false;
                    "
                    >Précédent</v-btn
                >
            </div>
        </div>
    </v-card>
</template>

<script lang="ts">
import DocumentWizard from "../document/DocumentWizard.vue";
import Loan from "./Loan.vue";
import Commission from "./Commission.vue";
import ZTill from "./ZTill.vue";
import CurrentAccount from "./CurrentAccount.vue";
import WithoutInvoice from "./WithoutInvoice.vue";
import AutoSales from "./AutoSales.vue";
import CashPayment from "./CashPayment.vue";
import Remittance from "./Remittance.vue";
import { Component, Vue, Watch, toNative } from "vue-facing-decorator";
import { Prop, Inject } from "vue-facing-decorator";

@Component({
    components: {
        DocumentWizard,
        Loan,
        Commission,
        ZTill,
        CurrentAccount,
        WithoutInvoice,
        AutoSales,
        CashPayment,
        Remittance,
    },
})
export class ReconciliationWizard extends Vue {
    @Prop({ default: null }) reconciliationVue: any;
    @Prop({ default: false }) insideBank: boolean;

    loadingDocument = false;
    wizardStep = 1;

    documentWizard = false;
    documentWizardGlobalStep = "";

    validateLoading = false;

    isNewlyUploadedDocument = false;

    startUpload() {
        this.documentWizard = true;
    }

    get documentType() {
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            const aaName = this.reconciliationVue.isThirdPartyGroup(group);
            if (!aaName) {
                continue;
            }
            if (aaName.startsWith("401")) {
                return "PURCHASE_INVOICE";
            }
            if (aaName.startsWith("411")) {
                return "SALES_INVOICE";
            }
        }
        return undefined;
    }

    async onNewDocument(document) {
        this.reconciliationVue.onNewDocument(document);
    }

    @Inject({ from: "initialHasReconciliationDocuments", default: null })
    readonly initialHasReconciliationDocuments;

    get hasUploadedFiles(): boolean {
        return this.initialHasReconciliationDocuments || this.isNewlyUploadedDocument;
    }

    get showBTWizard() {
        if (this.hasUploadedFiles) {
            return false;
        }
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            if (this.reconciliationVue.showMenuForBT(group)) {
                return group;
            }
        }
        return null;
    }

    get showDocWizard() {
        if (this.hasUploadedFiles) {
            return false;
        }
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            if (this.reconciliationVue.showMenuForDoc(group)) {
                return group;
            }
        }
        return null;
    }

    get status() {
        if (this.hasUploadedFiles) {
            return this.$t("reconciliation.status.UPLOADED_FILE");
        }
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        let status = "";
        for (const group of groupedAccountingLines) {
            if (status) status += ". ";
            status += this.reconciliationVue.groupAllocation(group);
        }
        return status;
    }

    // async validate() {
    //     this.validateLoading = true;
    //     await this.reconciliationVue.updateReconciliation(true);
    //     await this.reconciliationVue.refresh();
    //     this.validateLoading = false;
    // }

    get listItemClass() {
        let docClass = "mb-2 oss-list-item";
        if (this.$vuetify.display.mobile) {
            docClass += " px-2";
        }
        return docClass;
    }

    chooseExisitingDocument() {
        if (!this.reconciliationVue.loadingDocument) {
            this.reconciliationVue.documentPanel = !this.reconciliationVue.documentPanel;
            this.reconciliationVue.bankTransactionPanel = false;
            this.reconciliationVue.reconciliationPanel = false;
        }
    }

    get loanBTItem() {
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            const result = this.reconciliationVue.getLoanBT(group);
            if (result) {
                return result;
            }
        }
        return null;
    }

    get commissionBTItem() {
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            const result = this.reconciliationVue.getCommissionBTItem(group);
            if (result) {
                return result;
            }
        }
        return null;
    }

    get zTillBT() {
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            const result = this.reconciliationVue.getZTillBT(group);
            if (result) {
                return result;
            }
        }
        return null;
    }

    get currentAccountBTItem() {
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            const result = this.reconciliationVue.getCurrentAccountBTItem(group);
            if (result) {
                return result;
            }
        }
        return null;
    }

    get withoutInvoiceBT() {
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            const result = this.reconciliationVue.getWithoutInvoiceBT(group);
            if (result) {
                return result;
            }
        }
        return null;
    }

    get withoutInvoiceStepCount() {
        let count = 0;
        if (this.withoutInvoiceBT) {
            count++;
        }
        if (this.commissionBTItem) {
            count++;
        }
        if (this.loanBTItem) {
            count++;
        }
        if (this.showAutoSalesReconciliation) {
            count++;
        }
        return count;
    }

    onGlobalStepChange(step: string) {
        this.documentWizardGlobalStep = step;
    }

    onFileUploaded() {
        this.documentWizard = false;
        this.isNewlyUploadedDocument = true;
        // this.$router.go(-1);
    }

    get showDocumentWizardPreviousBtn() {
        if (this.documentWizardGlobalStep == "uploadDocuments") return false;
        return !["invoice"].includes(this.documentWizardGlobalStep);
    }

    backToGeneralWithoutInvoiceStep() {
        if (this.withoutInvoiceStepCount > 1) {
            this.wizardStep = 3;
        } else {
            this.wizardStep = 1;
        }
    }

    nextToGeneralWithoutInvoiceStep() {
        if (this.withoutInvoiceStepCount > 1) {
            this.wizardStep = 3;
            return;
        }
        if (this.withoutInvoiceBT) {
            this.wizardStep = 8;
            return;
        }
        if (this.commissionBTItem) {
            this.wizardStep = 5;
            return;
        }
        if (this.loanBTItem) {
            this.wizardStep = 4;
            return;
        }
        if (this.showAutoSalesReconciliation) {
            this.wizardStep = 9;
            return;
        }
    }

    get showAutoSalesReconciliation() {
        const groupedAccountingLines = this.reconciliationVue.groupedAccountingLines;
        for (const group of groupedAccountingLines) {
            const result = this.reconciliationVue.showAutoSalesReconciliation(group);
            if (result) {
                return result;
            }
        }
        return null;
    }
}

export default toNative(ReconciliationWizard);
</script>
